import React, { FC, useState } from "react";
import "./productList.scss";

import productImage from "../../../assets/placeholder/Product-Education.png";
import CardMenu from "../../../shared/components/CourseComponents/CardMenu";
// import ContentForm from "../ContentForm";
import { Col, Row } from "antd";

interface ContentListsProps {
  contents: any;
  currentContent: any;
  setCurrentContent: Function;
  setShowContent: Function;
  setShowDelete: Function;
  setShowForm:Function;
  setShowQuickQuizForm: Function;
}

const ContentLists: FC<ContentListsProps> = (props) => {
  const {
    contents,
    currentContent,
    setCurrentContent,
    setShowContent,
    setShowDelete,
    setShowForm,
    setShowQuickQuizForm,
  } = props;

  const [menuVisible, setMenuVisible] = useState<boolean>(false);
  
  const handleEdit = (id:any) => {
    setShowForm(true);
    setCurrentContent(id);
  };

  const handleDelete = (id:any) => {
    setShowDelete(true);
    setCurrentContent(id);
  };
  

  return (
    <>
      <Row className="content-list" gutter={[24, 12]}>
        {contents.map((content: any, i: number) => (
          <Col xs={8} xl={6} key={"PRODUCT#"+i+"_"+content?.productId}>
            <div
              className={
                "content-list__card" +
                (menuVisible && currentContent.id === content.productId
                  ? " display-overlay"
                  : "")
              }
              key={i}
              onClick={(event) => {
                setCurrentContent(content);//content?.productId
                setShowContent(true);
              }}
            >
              <div className="content-list__thumbnail">
                <img
                  src={content?.thumbnailPath || productImage}
                  alt=""
                  className="content-list__thumbnail__image"
                  onError={event => {
                    event.currentTarget.src = productImage
                    event.currentTarget.onerror = null
                  }}
                />
       
                <div className="content-list__overlay">
                  <div className="content-list__details">
                    {/* <div className="content-list__subject">
                      <img src={subjectIcon} alt="" /> Physics,Chemistry, +3
                    </div> */}
                    <div className="content-list__subject">
                       {content?.className}
                    </div>
                  </div>
                  <div
                    className="content-list__menu"
                    onClick={(event) => {
                      event.stopPropagation();
                      //setCurrentContent(content?.id);
                    }}
                  >
                    <CardMenu
                      menuText="Content"
                      handleEdit={()=>handleEdit(content)} //content?.id
                      handleDelete={()=>handleDelete(content)}
                      handleVisibleChange={setMenuVisible}
                      useMenuIconWhite={true}
                    />
                  </div>
                </div>
              </div>
              <div className="content-list__title">{content?.productName}</div>
              {/* <div className="content-list__id">ID: {content?.productId}</div> */}
            </div>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ContentLists;
